var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.81973007 C0,5.01555173 0.650555458,4.36363636 1.45609371,4.36363636 L10.1802699,4.36363636 C10.9844483,4.36363636 11.6363636,5.01419182 11.6363636,5.81973007 L11.6363636,14.5439063 C11.6363636,15.3480846 10.9858082,16 10.1802699,16 L1.45609371,16 C0.65191536,16 0,15.3494445 0,14.5439063 L0,5.81973007 L0,5.81973007 L0,5.81973007 L0,5.81973007 L0,5.81973007 Z M14.5454545,11.6363636 C15.3487778,11.6363636 16,10.9835069 16,10.1818182 L16,8.72727273 L14.5454545,8.72727273 L14.5454545,10.1818182 L13.0909091,10.1818182 L13.0909091,11.6363636 L14.5454545,11.6363636 L14.5454545,11.6363636 L14.5454545,11.6363636 L14.5454545,11.6363636 Z M16,1.45454545 C16,0.651222182 15.3471432,0 14.5454545,0 L13.0909091,0 L13.0909091,1.45454545 L14.5454545,1.45454545 L14.5454545,2.90909091 L16,2.90909091 L16,1.45454545 L16,1.45454545 L16,1.45454545 L16,1.45454545 Z M5.81818182,0 C5.01485855,0 4.36363636,0.652856784 4.36363636,1.45454545 L4.36363636,2.90909091 L5.81818182,2.90909091 L5.81818182,1.45454545 L7.27272727,1.45454545 L7.27272727,0 L5.81818182,0 L5.81818182,0 L5.81818182,0 L5.81818182,0 Z M8.72727273,0 L11.6363636,0 L11.6363636,1.45454545 L8.72727273,1.45454545 L8.72727273,0 L8.72727273,0 L8.72727273,0 L8.72727273,0 L8.72727273,0 Z M14.5454545,4.36363636 L16,4.36363636 L16,7.27272727 L14.5454545,7.27272727 L14.5454545,4.36363636 L14.5454545,4.36363636 L14.5454545,4.36363636 L14.5454545,4.36363636 L14.5454545,4.36363636 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show-COD/POD-on-receipt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/user-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/primary/black"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#FFDB00",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyNew);
export default __webpack_public_path__ + "static/media/copy-new.eff57e9fb75e2e54197499daf2f9c3ba.svg";
export { ForwardRef as ReactComponent };